function AmazonMappingService(ApiService) {
  'ngInject';

  const service = {};
  service.createMapping = function(amazonForm, orgId, callbackFunc) {
    let data= {
      name: amazonForm.name,
      debit_account: amazonForm.debitAccount.id,
      credit_account: amazonForm.creditAccount.id,
      narration: amazonForm.narration
    };
    ApiService.post(`/organizations/${orgId}/amazon_mappings.json`, data, callbackFunc);
  };

  service.getMappping = function(orgId, callbackFunc) {
    ApiService.get(`/organizations/${orgId}/amazon_mapping.json`,callbackFunc);
  };

  service.deleteMapping = function(orgId, mappingId, callbackFunc) {
    ApiService.delete(`/organizations/${orgId}/amazon_mapping.json`, mappingId, callbackFunc);
  };

  service.getAccounts = function(orgId, callbackFunc) {
    ApiService.get(`/organizations/${orgId}/accounts.json`, callbackFunc);
  };

  return service;
}

export default{
  name: 'AmazonMappingService',
  fn: AmazonMappingService
}
